module.exports = __webpack_public_path__ + "img/icon-sv1.2d7c8076.png";